import React from "react"
import Avatar from '@mui/material/Avatar';
import { Alert, Card, CardActions, CardHeader, CardContent, IconButton, IconButtonProps, Stack, Typography } from '@mui/material';
import { red, blue, orange } from '@mui/material/colors';
import LineAxisIcon from '@mui/icons-material/LineAxis';



const Dash =()=>{

  const tarjeta=(letra, titulo, dato1, dato2, dato3, coloR)=>{
    return(
    <Card sx={{ maxWidth: 345 }}>
      {coloR==='blue' ?
        <CardHeader
          avatar={<Avatar sx={{ bgcolor: blue[500] }} aria-label="recipe">{letra}</Avatar>}
          title={titulo}
        />
      : coloR==='red' ?
        <CardHeader
          avatar={<Avatar sx={{ bgcolor: red[500] }} aria-label="recipe">{letra}</Avatar>}
          title={titulo}
        />
        :
        <CardHeader
          avatar={<Avatar sx={{ bgcolor: orange[500] }} aria-label="recipe">{letra}</Avatar>}
          title={titulo}
        />
      }
      
      <CardContent>
        <Typography variant="body2" color="text.secondary">
          {dato1}: 10<br/>
          {dato2}: 20<br/>
          {dato3}: 30<br/>
        </Typography>
      </CardContent>
      <CardActions disableSpacing>
        <IconButton aria-label="Graficar"> 
          <LineAxisIcon /> 
        </IconButton>
      </CardActions>
    </Card>
    )
  }

  return(
    <div className="container">
      <div className="row mt-3 mb-3">
        <Stack sx={{ width: '100%' }} spacing={2}>
          <Alert severity="success">DASHBOARD</Alert>
        </Stack>
      </div>

      <div className="row mt-3">
        <div className="col-sm-3">
          {tarjeta('P','Proyectos','Registrados','En Curso','Total','blue')}
        </div>

        <div className="col-sm-3">
          {tarjeta('B','Beneficiarios','Registrados','Culminados','Total','red')}
        </div>

        <div className="col-sm-3">
          {tarjeta('E','Equipo de Trabajo','Registrados','Activos','Total','orange')}
        </div>

      </div>
    </div>
  )
}

export default Dash